import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import ErrorBoundary from "./common/Components/ErrorBoundary/ErrorBoundary";
import Toast from "./common/Components/Toast/Toast";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import store from "./store";


import 'react-quill/dist/quill.snow.css';


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <>
    <ErrorBoundary>
      <Provider store={store}>
        <App />
        <Toast />
      </Provider>
    </ErrorBoundary>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
